import { render, staticRenderFns } from "./CertificationEn.vue?vue&type=template&id=7724ef98&scoped=true&"
import script from "./CertificationEn.vue?vue&type=script&lang=js&"
export * from "./CertificationEn.vue?vue&type=script&lang=js&"
import style0 from "./CertificationEn.vue?vue&type=style&index=0&id=7724ef98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7724ef98",
  null
  
)

export default component.exports